import { axiosInstance, ENDPOINT } from 'common/constants';
import { handleResponse } from 'common/helpers';

export const fmeaComponentTemplatesService = {
  listTemplates,
  getTemplate,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  listComponentTypes,
  parseCsv,
};

function listTemplates(params) {
  return handleResponse(axiosInstance.get(ENDPOINT.GET_FMEA_COMPONENT_TEMPLATES, { params }));
}

function getTemplate(templateId) {
  return handleResponse(axiosInstance.get(ENDPOINT.GET_FMEA_COMPONENT_TEMPLATE(templateId)));
}

function createTemplate(body) {
  return handleResponse(axiosInstance.post(ENDPOINT.CREATE_FMEA_COMPONENT_TEMPLATE, body));
}

function updateTemplate(templateId, body) {
  return handleResponse(axiosInstance.put(ENDPOINT.UPDATE_FMEA_COMPONENT_TEMPLATE(templateId), body));
}

function deleteTemplate(templateId) {
  return handleResponse(axiosInstance.delete(ENDPOINT.DELETE_FMEA_COMPONENT_TEMPLATE(templateId)));
}

function listComponentTypes() {
  return handleResponse(axiosInstance.get(ENDPOINT.GET_FMEA_COMPONENT_TYPES));
}

function parseCsv(file) {
  const form = new FormData();
  form.append('file', file);
  return handleResponse(axiosInstance.post(ENDPOINT.PARSE_FMEA_COMPONENT_CSV, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
}
